import {Component, Inject, OnInit} from '@angular/core';
import {BroadcastsService} from "../../services/broadcasts.service";
import {Broadcast, ManualData} from "../../model/broadcast/broadcast";
import {Observable} from "rxjs";
import {map, shareReplay, take} from "rxjs/operators";
import {BreakpointObserver, Breakpoints} from "@angular/cdk/layout";
import {MAT_DIALOG_DATA, MatDialogRef, MatDialogModule} from "@angular/material/dialog";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {AsyncPipe} from "@angular/common";
import {StatusComponent} from "../../broadcast-layer-module/broadcast-layer/status/status.component";

@Component({
    selector: 'app-undo-dialog',
    templateUrl: './undo-dialog.component.html',
    styleUrls: ['./undo-dialog.component.scss'],
    standalone: true,
    imports: [
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        AsyncPipe,
        StatusComponent
    ]
})
export class UndoDialogComponent implements OnInit {

  history: ManualData[];
  undoPreview: Broadcast;
  previewIndex: number;

  isMobile$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  constructor(
    private breakpointObserver: BreakpointObserver,
    public dialogRef: MatDialogRef<UndoDialogComponent>,
    private broadcastService: BroadcastsService,
    @Inject(MAT_DIALOG_DATA) private broadcastUid: string,
  ) { }

  ngOnInit(): void {
    this.broadcastService.getBroadcast(this.broadcastUid).subscribe(next => {
      this.undoPreview = next;
      this.previewIndex = next.manualData.index;
    });
    this.broadcastService.getManualDataHistory(this.broadcastUid).pipe(take(1)).subscribe(next => {
      this.history = next;
    });
  }

  undo() {
    const manualData = this.history.find(md => md.index === this.previewIndex - 1);
    if (manualData) {
      this.previewIndex--;
      this.undoPreview.manualData = manualData;
    }
  }

  redo() {
    const manualData = this.history.find(md => md.index === this.previewIndex + 1);
    if (manualData) {
      this.previewIndex++;
      this.undoPreview.manualData = manualData;
    }
  }

  confirm() {
    this.broadcastService.updateManualData(this.undoPreview).finally(() => {
      this.dialogRef.close();
    });
  }

  close() {
    this.dialogRef.close();
  }
}
